/**
 * Logo — шрифтовой wordmark `AI AgentCEO` (D-031.7 spec, AD).
 * Inter/Onest semibold, accent-brand-primary, AI с opacity 0.7 для visual hierarchy.
 *
 * Sizes (по поверхностям):
 *   sm  20px — mobile hero / dashboard sidebar
 *   md  24px — landing header
 *   lg  32px — AuthLayout SidePanel (бренд-якорь)
 *
 * Цвет (light): solid var(--accent-brand-primary) #4338CA
 * Цвет (dark/inverse surface): var(--accent-brand-on-inverse) #A5B4FC
 *
 * Градиент в логотипе ЗАПРЕЩЁН — only solid color.
 */
type Size = 'sm' | 'md' | 'lg'
type Tone = 'brand' | 'inverse'

const sizeCls: Record<Size, string> = {
  sm: 'text-[20px] tracking-normal',
  md: 'text-[24px] -tracking-[0.02em]',
  lg: 'text-[32px] -tracking-[0.02em]',
}

const toneCls: Record<Tone, string> = {
  // Light surface — brand primary
  brand: 'text-accent-brand-primary',
  // Inverse / dark surface — lighter pair (indigo-300 equivalent)
  inverse: 'text-[color:#A5B4FC]',
}

export function Logo({
  size = 'md',
  tone = 'brand',
  href = '/',
  className = '',
}: {
  size?: Size
  tone?: Tone
  href?: string | null
  className?: string
}) {
  // Visual hierarchy "AI" → "AgentCEO" через opacity-80 на primary brand
  // (НЕ opacity-70 — даёт contrast 3.5:1, fail WCAG 2.2 AA).
  // opacity-80 на indigo-600 vs near-white даёт ~5.8:1 — passes AA+AAA для large.
  const inner = (
    <span className={`font-display font-semibold leading-none ${sizeCls[size]} ${toneCls[tone]} ${className}`}>
      <span className="opacity-80">AI</span>
      <span>&nbsp;AgentCEO</span>
    </span>
  )
  if (href === null) return inner
  return (
    <a href={href} aria-label="AgentCEO — на главную" className="inline-block focus:outline-none focus:ring-2 focus:ring-border-focus/40 rounded">
      {inner}
    </a>
  )
}
